
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRemoveFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.753 13.065a.841.841 0 0 1-1.19 1.189L8.125 9.813l-4.441 4.44a.84.84 0 0 1-1.189-1.19l4.441-4.44-4.44-4.44a.84.84 0 0 1 1.19-1.189l4.44 4.441 4.44-4.442a.84.84 0 1 1 1.19 1.19l-4.442 4.44 4.44 4.442Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M13.7527 13.065C13.9103 13.2227 13.9989 13.4365 13.9989 13.6594C13.9989 13.8823 13.9103 14.0962 13.7527 14.2538C13.595 14.4114 13.3812 14.5 13.1583 14.5C12.9353 14.5 12.7215 14.4114 12.5639 14.2538L8.12416 9.81266L3.68303 14.2524C3.52539 14.41 3.31158 14.4986 3.08864 14.4986C2.8657 14.4986 2.65189 14.41 2.49425 14.2524C2.33661 14.0948 2.24805 13.8809 2.24805 13.658C2.24805 13.4351 2.33661 13.2213 2.49425 13.0636L6.93538 8.62388L2.49565 4.18275C2.33801 4.02511 2.24945 3.8113 2.24945 3.58836C2.24945 3.36542 2.33801 3.15162 2.49565 2.99397C2.65329 2.83633 2.8671 2.74777 3.09004 2.74777C3.31298 2.74777 3.52679 2.83633 3.68443 2.99397L8.12416 7.43511L12.5653 2.99327C12.7229 2.83563 12.9367 2.74707 13.1597 2.74707C13.3826 2.74707 13.5964 2.83563 13.7541 2.99327C13.9117 3.15092 14.0003 3.36472 14.0003 3.58766C14.0003 3.8106 13.9117 4.02441 13.7541 4.18205L9.31294 8.62388L13.7527 13.065Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/remove-file.9abe58fa651c72d9c7caefa988794acd.svg"),
        {
          React: SvgRemoveFile,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      